import * as Yup from "yup";

export const KPISchema = Yup.object().shape({
    _id: Yup.mixed(),
    name: Yup.string().required(),
    target: Yup.string()
        .matches(/^\d{0,3}(,\d{3})*$/)
        .required(),
    startDate: Yup.date().required(),
    endDate: Yup.date().required(),
    nodeId: Yup.string().required()
});
